import { UserEditorComponents } from 'components/organisms/tasks/criteria/editor-components';
import { FilterableField } from 'components/organisms/tasks/fields';
import { GetSelectEditorComponents } from 'components/organisms/tasks/filter-box/utils';
import { FieldFilter } from 'components/organisms/tasks/filters';
import { ApiFilter } from 'utils/simple-search-filter/simple-search-filter';
import { TimesheetReportViewDefinition } from './types';

export const isValidViewDefinition = ({
  filter,
}: TimesheetReportViewDefinition): boolean =>
  filter.criteria.filter(FieldFilter.isValid).length > 0;

export const viewDefinitionComparator = (
  oldDefinition: TimesheetReportViewDefinition,
  newDefinition: TimesheetReportViewDefinition,
): boolean => {
  if (oldDefinition.filter?.type !== newDefinition.filter?.type) {
    return true;
  }

  const oldFilters = (oldDefinition.filter?.criteria ?? []).filter(
    FieldFilter.isValid,
  );
  const newFilters = (newDefinition.filter?.criteria ?? []).filter(
    FieldFilter.isValid,
  );

  if (
    oldFilters.length !== newFilters.length ||
    ApiFilter.toQueryStringFormat(oldFilters) !==
      ApiFilter.toQueryStringFormat(newFilters)
  ) {
    return true;
  }

  return false;
};

export const getFilterEditorPopoverComponents: GetSelectEditorComponents = (
  field: FilterableField,
) => {
  if (field.fieldName === 'customer') {
    return UserEditorComponents;
  }

  return undefined;
};
